import { QueryClient } from "@tanstack/react-query";
import type { QueryClientConfig } from "@tanstack/react-query";

/**
 * Exported so a test can build a client that behaves like this one. The shared
 * test harness uses `gcTime: 0` and the default `refetchOnMount`, which between
 * them re-fetch an entry a test seeded — hiding whether the code under test
 * actually avoided a request.
 */
export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      retry: false,
    },
  },
};

export const queryClient = new QueryClient(queryClientConfig);
